import { render } from "./turmas_do_coordenador_single.vue?vue&type=template&id=0adebc88&scoped=true"
import script from "./turmas_do_coordenador_single.vue?vue&type=script&lang=js"
export * from "./turmas_do_coordenador_single.vue?vue&type=script&lang=js"

import "./turmas_do_coordenador_single.vue?vue&type=style&index=0&id=0adebc88&lang=scss&scoped=true"
import "./turmas_do_coordenador_single.vue?vue&type=style&index=1&id=0adebc88&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0adebc88"]])

export default __exports__